import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { LocalizationMessages } from "../../localization/messages";
import { ThemeUtils } from "../../utils";
import { UserContextSelectors } from "../../redux/selectors";
import { useIntl } from "react-intl";
import { useMiniCashierCommunicationHandler } from "../../components/MiniCashier";
import { useSelector } from "react-redux";
import LoginCTAButton from "../../components/LoginCTAButton";
import CTAButton from "../../components/common/Button/CTAButton";
import { ThemeProvider, useTheme } from "styled-components";
import { ButtonsVariant, RegulationTypeIds } from "../../constants";
import { useAccountCommunicationHandlers } from "../../hooks";
import { Brand } from "../../configurations";
import { PageContextUtils } from "../../utils";
import { BrandUtils } from "../../utils/brandUtils";
import { TrackingInfo } from "../../components/tracking/TrackingInfoHeader";

export const HeaderButtonsPC = props => {
  const { noRegister = false } = props;
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const { formatMessage } = useIntl();
  const { openCashier } = useMiniCashierCommunicationHandler();
  const { openLogin, useOpenRegister } = useAccountCommunicationHandlers();
  const theme = useTheme();
  const brandId = useSelector(UserContextSelectors.brandId);
  const { regulationTypeId } = PageContextUtils.getRegulationData();
  const { langId } = PageContextUtils.getLocalizationData();
  const useRegister = useOpenRegister();

  const handleCashier = async () => {
    openCashier({
      Area: "PC Header",
      Element: "Deposit button",
      Source: "Unified Client",
      AnalyticsData: {
        category: "Header",
        action: "open deposit",
        label: "Deposit"
      }
    });
  };

  const getColor = useCallback(() => {
    const style = theme.getHeaderButtonPcStyles();
    if (style.colors.headerButtonPrimary) {
      return style.colors.headerButtonPrimary;
    } else {
      return style.colors.primary;
    }
  }, [theme]);

  const getHoverColor = useCallback(() => {
    const style = theme.getHeaderButtonPcStyles();
    if (style.colors.headerButtonBrandColor) {
      return style.colors.headerButtonBrandColor;
    } else {
      return style.colors.brandColor;
    }
  }, [theme]);

  const registerTitle = useMemo(() => {
    const isComAndUk =
      Brand.Sport_Com === brandId && regulationTypeId === RegulationTypeIds.UK;

    let title = formatMessage(LocalizationMessages.register);
    if (
      (isComAndUk || BrandUtils.isPokerClient()) &&
      langId?.toLowerCase() === "en"
    )
      title = "Sign up";

    return title;
  }, [brandId, regulationTypeId, formatMessage, langId]);

  return (
    <ThemeProvider theme={theme.getHeaderButtonPcStyles()}>
      <div className="headerButtons">
        {!isAuthenticated ? (
          <React.Fragment>
            {!noRegister && (
              <CTAButton
                onClickFunc={useRegister}
                title={registerTitle}
                type="Register"
                id="topMenuaCregisterButton"
                color={getColor()}
                variant={ButtonsVariant.Contained}
                hoverColor={getHoverColor()}
                trackingInfo={TrackingInfo}
                dataTestId="topMenuaCregisterButton"
                isPremiumButton={false}
              />
            )}
            <LoginCTAButton
              key="login"
              btnContext="topMenu"
              type="Login"
              onClick={openLogin}
              title={formatMessage(LocalizationMessages.login)}
              aCclassName="aCloginButton"
              trackingInfo={TrackingInfo}
            />
          </React.Fragment>
        ) : (
          <CTAButton
            onClickFunc={handleCashier}
            title={formatMessage(LocalizationMessages.deposit)}
            type="Cashier"
            id="topMenuaCcashierButton"
            color={getColor()}
            variant={ButtonsVariant.Contained}
            hoverColor={getHoverColor()}
            trackingInfo={TrackingInfo}
            dataTestId="topMenuaCcashierButton"
            isPremiumButton={ThemeUtils.isMrGreenTheme()}
          />
        )}
      </div>
    </ThemeProvider>
  );
};

HeaderButtonsPC.propTypes = {
  noRegister: PropTypes.bool
};
